module.exports = __webpack_public_path__ + "img/04_kii_09.872b7d3a.jpg";